import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class LocalBranchDbTableDefinition extends DbTableDefinition {
  tableName = 'local_branches';
  tableStructure = `(id BIGINT(20) PRIMARY KEY null,
      label TEXT NOT NULL,
      databag LONGTEXT,
      oin VARCHAR(50),
      defaultpersonid BIGINT(20),
      defaultpersonlabel TEXT,
      defaultpersonphone TEXT,
      defaultpersonprimaryphone TEXT,
      defaultpersonemail LONGTEXT,
      locationid BIGINT(20),
      locationlabel TEXT,
      customerid BIGINT(20),
      inetaddress LONGTEXT,
      validmatchingradius DOUBLE,
      extid VARCHAR(60),
      validlongitude DOUBLE,
      validlatitude DOUBLE,
      email LONGTEXT,
      geodataisaddresspreciseormanual BOOLEAN,
      defaultpersonmobile TEXT,
      defaultpersonfax TEXT,
      name TEXT,
      shortname TEXT,           
      phone TEXT, 
      fax TEXT    
      );`;

  constructor() {
    super();
    // Add UpdateStatements to Map

    if (Capacitor.getPlatform() === 'web') {
      this.alterStatements.push({
        table: this.tableName,
        col: 'geodataismanual',
        type: 'BOOLEAN',
      });
    } else {
      this.updateStatements.set(9, [
        `ALTER TABLE ${this.tableName} ADD COLUMN geodataismanual BOOLEAN;`,
      ]);
    }
  }
}
